export default __webpack_public_path__ + "static/media/WeShip1.81c32637.png";